import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import Content from '../../../layout/Content';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import {
  clearBaggageItem,
  getBaggageItemById,
  postAddItemComment,
} from '../../../../actions';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import { ITEM_PATH } from '../../../../config/paths';
import ItemBasicInformationResource from './ItemBasicInformationResource';
import ItemToolbar from './ItemToolbar';

const Item = ({
  breadcrumbs,
  dispatchClearBaggageItem,
  dispatchGetBaggageItemById,
  match: {
    params: { id },
  },
  loading,
  baggage,
  dispatchPostAddItemComment,
}) => {
  useLayoutEffect(() => {
    dispatchGetBaggageItemById(id);

    return () => {
      dispatchClearBaggageItem();
    };
  }, []);

  const handleItemCommentSubmit = async (formValues) => {
    const { itemComment } = formValues;
    await dispatchPostAddItemComment({
      id,
      comment: itemComment,
    });
    dispatchGetBaggageItemById(id);
  };

  let content = null;
  let toolbar = null;

  if (loading) content = <Loader />;
  else if (baggage.isEmpty())
    content = <NoDataResource returnPage={ITEM_PATH} />;
  else {
    const baggageJson = baggage.toJS();
    content = (
      <ItemBasicInformationResource
        {...baggageJson}
        handleItemCommentSubmit={handleItemCommentSubmit}
      />
    );
    toolbar = <ItemToolbar itemId={id} status={baggageJson.status} />;
  }

  return (
    <Content
      title="Equipaje"
      breadcrumbs={breadcrumbs}
      content={content}
      toolbar={toolbar}
    />
  );
};

Item.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearBaggageItem: PropTypes.func.isRequired,
  dispatchGetBaggageItemById: PropTypes.func.isRequired,
  match: matchPropTypes.isRequired,
  loading: PropTypes.bool,
  baggage: PropTypes.instanceOf(Immutable.Map).isRequired,
  dispatchPostAddItemComment: PropTypes.func.isRequired,
};

Item.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ BaggageUnit }) => ({
  breadcrumbs: [
    ...BaggageUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Equipajes',
      href: ITEM_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  baggage: BaggageUnit.Item.getIn(['current', 'content']),
  loading: !BaggageUnit.Item.getIn(['current', 'activity']).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetBaggageItemById: getBaggageItemById,
  dispatchClearBaggageItem: clearBaggageItem,
  dispatchPostAddItemComment: postAddItemComment,
};

export default connect(mapStateToProps, mapDispatchToProps)(Item);
